var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-container absolute" }, [
      _c("div", { staticClass: "loader-inner-container absolute" }, [
        _c("div", { staticClass: "spinner relative" }, [
          _c("div", {
            staticClass:
              "double-bounce1 absolute w-100 brdr-circle bg-cl-th-success"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "double-bounce2 absolute w-100 brdr-circle bg-cl-th-success"
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }